import z from 'zod';

const findNearDoctorFormValidationSchema = z.object({
  zip: z.string().min(1, { message: 'ZIP code is required' }).max(5, {
    message: 'ZIP code must be 5 digits',
  }),
  radius: z.string().min(1, { message: 'Radius is required' }),
});

export type FindNearDoctorFormData = z.infer<
  typeof findNearDoctorFormValidationSchema
>;

export { findNearDoctorFormValidationSchema };
